import { render } from "./NetworkItem.vue?vue&type=template&id=6fe09372&scoped=true"
import script from "./NetworkItem.vue?vue&type=script&lang=js"
export * from "./NetworkItem.vue?vue&type=script&lang=js"

import "./NetworkItem.vue?vue&type=style&index=0&id=6fe09372&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6fe09372"]])

export default __exports__